import React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Icon from '@mui/material/Icon';
import { useDispatch } from "react-redux";
import { logOut, setLogedinUserInfo } from '../../login/Login_reducer';
import { Cookies } from "react-cookie";
import store from "../../../store";

export const OwnerHeader = () => {

  const location = useLocation();
  const { pathname } = location;
  const splitLocation = pathname.split("/");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [selectMenu, setselectMenu] = React.useState(null);
  const open = Boolean(anchorEl);
  const cookies = new Cookies();

  const backtoUser =()=>{
    cookies.set("userInfo", cookies.get('originaluserInfo'), { path: '/' });
            cookies.set("lastLoginTime", cookies.get('originaluserlastLoginTime'),{ path: '/' });
            // cookies.remove("secret", { path: '/' });
            // cookies.remove("token", { path: '/' });

            cookies.remove("originaluserInfo", { path: '/' });
            cookies.remove("originaluserlastLoginTime", { path: '/' });
            cookies.remove("store_access", { path: "/" });
            // cookies.remove("token", { path: '/' });
           store.dispatch(setLogedinUserInfo(cookies.getAll()));

            // handleClose()
            navigate('/users', { replace: true })
}



  const handleClick = (val, event) => {
    setselectMenu(val);

    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const gotodashboard = () => {
    console.log("gotodashboard");
    navigate(`/${store.getState().loginUserKey.userInfo.type}-dashboard`, { replace: true });
  }
  const gotosafety = () => {
    console.log("gotosafety");
    navigate("/safety-measurements", {
      replace: true,
    });
  };
  const showMenuBar = () => {
    var elem = document.getElementById("topMenuLists");
    elem.classList.toggle("addCSS");
  };

  return (
    <div className="pageWrapper">
      <Grid container spacing={0} className="topMenu">
        <Grid item xs={12} md={2} className="topLogo">
          <div className="loginFormLogo">
            <img
              src="https://d37pbainmkhx6o.cloudfront.net/fryright_images/logo.png"
              className="App-logo"
              alt="logo"
            />
          </div>
          <div className="navbarToggle" onClick={showMenuBar}>
            <Button id="fade-button">
              <Icon className="toggleMenu">clear_all</Icon>
            </Button>
          </div>
        </Grid>

        <Grid item xs={12} md={7} id="topMenuLists" className="topMenuLists">
          <div className="topMenuListsWrapper">
            <Button onClick={() => gotodashboard()} className={pathname.includes("owner-dashboard") ? "active" : ""}>Dashboard</Button>
            <Button
                id="fade-button"
                aria-controls={open ? "fade-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={() => gotosafety()}
                className={
                  pathname.includes("safety-measurements")
                    ? "active"
                    : ""
                }
              >
                MSDS
              </Button>
          </div>
        </Grid>

        <Grid item xs={12} md={3} className="topRightMenu">
          <Button className="goToHome" onClick={() => navigate('/home')}>
            Go To Home
          </Button>
          <Button
            className="myAccount"
            id="fade-button"
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={(evt) => handleClick(7, evt)} 
          >
            <Icon className="account_circle">account_circle</Icon>{" "}
            <Icon className="expand_more">expand_more</Icon>
          </Button>
        </Grid>
      </Grid>

      {selectMenu === 7 && (
        <Menu
          id="fade-menu"
          MenuListProps={{
            "aria-labelledby": "fade-button",
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          <MenuItem  onClick={() => {
              navigate("/myaccount", { replace: true });
              setAnchorEl(false)
            }} className={pathname.includes("") ? "active" : ""}>My Account</MenuItem>
          {/* <MenuItem onClick={() => {
              navigate("/myaccount", { replace: true });
            }}>My Account</MenuItem> */}
        {!cookies.get('originaluserInfo')? 
          <MenuItem
            onClick={() => {
              dispatch(logOut());
              const cookies = new Cookies();
              cookies.remove("userInfo", { path: "/" });
              cookies.remove("secret", { path: "/" });
              cookies.remove("token", { path: "/" });
              handleClose();
              navigate("/", { replace: true });
            }}
          >
            Log Out
          </MenuItem> :null}

          {cookies.get('originaluserInfo')? 
          <MenuItem onClick=
          {()=>backtoUser()}
          // {() => {
          //   // dispatch(logOut())
          //   cookies.set("userInfo", cookies.get('originaluserInfo'), { path: '/' });
          //   cookies.set("lastLoginTime", cookies.get('originaluserlastLoginTime'),{ path: '/' });
          //   // cookies.remove("secret", { path: '/' });
          //   // cookies.remove("token", { path: '/' });

          //   cookies.remove("originaluserInfo", { path: '/' });
          //   cookies.remove("originaluserlastLoginTime", { path: '/' });
          //   // cookies.remove("token", { path: '/' });
          //  store.dispatch(setLogedinUserInfo(cookies.getAll()));

          //   handleClose()
          //   navigate('/users', { replace: true })
          // }}
          
          >Back to Original Account</MenuItem> : null}
        </Menu>
      )}
    </div>
  );
};
